import { Injectable } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

import { UrlQueryParamService } from './url-query-param.service';

@UntilDestroy()
@Injectable({
	providedIn: 'root'
})
export class UrlService extends UrlQueryParamService {
	constructor(route: ActivatedRoute, protected router: Router) {
		super(route, router);
	}

	public getRouterEvents(): Observable<Event> {
		return this.router.events;
	}

	public getRouteLocation(): string {
		return this.router.url;
	}

	public initLocationChangeEventHandler(callback: Function): any {
		this.router.events.pipe(untilDestroyed(this)).subscribe(event => {
			if (event instanceof NavigationEnd) {
				return callback(event);
			}
		});
		return callback;
	}
}
